import Login from "../components/auth/Login";

export default function LoginPage({ setView }) {
  return <Login onLoginSuccess={setView} goToSignUp={() => setView("/signup")} />;
}
